import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AppPath } from '@app/app-path';
import { CassError } from '@core/models/cass-error';
import { Logger } from '@core/services/logger.service';
import { UserService } from '@core/services/user.service';
import { ActivateUserNavigationState } from '@shared/models/activate-user-navigation-state';
import { ContactDetailsPersistentModel } from '@shared/models/contact-details-persistent-model';
import { LoadingOverlayService } from '@shared/services/loading-overlay.service';
import { UserAlertService } from '@shared/services/user-alert.service';
import { BehaviorSubject, distinctUntilChanged } from 'rxjs';
import { SubSink } from 'subsink';

@Component({
	selector: 'cass-create-account-page',
	templateUrl: './create-account-page.component.html',
	styleUrls: ['./create-account-page.component.css']
})
export class CreateAccountPageComponent {
	private readonly COMPONENT_NAME = "CreateAccountPageComponent";

	registerCustomerForm: FormGroup;
	callingOut$ = new BehaviorSubject<boolean>(false);

	private _subs = new SubSink();

	constructor (
		public dialog: MatDialog,
		private _logger: Logger,
		private _userService: UserService,
		private _userAlertService: UserAlertService,
		private _loadingOverlayService: LoadingOverlayService,
		private _router: Router
	) {
		this.registerCustomerForm = new FormGroup({});

		this._subs.add(
			this.callingOut$
				.pipe(
					distinctUntilChanged()
				)
				.subscribe((isCallingOut: boolean) => {
					if (isCallingOut) {
						this._loadingOverlayService.showIndeterminateHorizontalProgressIndicator();
					}
					else {
						this._loadingOverlayService.hide();
					}
				}));
	}

	ngOnInit(): void {
	}

	ngOnDestroy(): void {
		this._subs.unsubscribe();
	}

	createAccount() {
		if (!this.registerCustomerForm.valid) {
			// trigger display of all field validation errors
			this.registerCustomerForm.markAllAsTouched();
			return;
		}

		const contactDetails: ContactDetailsPersistentModel = this.registerCustomerForm.value;
		contactDetails.loginName = "caasUser"

		this.callingOut$.next(true);
		this._userService.registerUser(contactDetails).subscribe({
			next: (res) => {
				this.callingOut$.next(false);
				/*				if (res === 'ACCEPTED') {*/
				const state = new ActivateUserNavigationState();
				state.email = contactDetails.email;

				this._router.navigate([AppPath.ActivateUser], { state: state });
				//	}
				//	else {
				//		// can we receive other responses?
				//	}
			},
			error: (error: CassError) => {
				this.callingOut$.next(false);
				this._userAlertService.errorByCassError(error);
			}
		});
	}
}
